import {
  ERROR,
  CLEAR_MATTER_TIME,
  CLEAR_MATTER_DISB_TIME,
} from "../types/index";

export const clearMatterDisbRecords = (data) => async (dispatch) => {
  try {
    dispatch({ type: CLEAR_MATTER_DISB_TIME });
  } catch (error) {
    dispatch({ type: ERROR, payload: error });
  }
};

export const clearMatterTimeRecords = (data) => async (dispatch) => {
  try {
    dispatch({ type: CLEAR_MATTER_TIME });
  } catch (error) {
    dispatch({ type: ERROR, payload: error });
  }
};
